import { Select as OriginalSelect } from 'antd';
import { withWrap } from '../../utils/hoc';

const Select = withWrap(OriginalSelect);

export default Select;
